const WorkIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5796 8.00645C21.6096 8.05892 21.6396 8.11138 21.6597 8.16385C21.8799 8.68863 22 9.26589 22 9.87464V16.6443C22 19.0478 20.1381 21 17.8458 21H6.15415C3.86186 21 2 19.0478 2 16.6443V9.88513C2 7.48163 3.86186 5.52945 6.15415 5.52945H8.81682C8.88689 4.12303 10.2883 3 12 3C13.7217 3 15.1131 4.12303 15.1832 5.51895H17.8458C19.4975 5.51895 20.9089 6.54752 21.5796 8.00641L21.5796 8.00645ZM14.1822 5.52945C14.0921 4.71079 13.1411 4.04956 12 4.04956C10.8589 4.04956 9.90791 4.71079 9.81782 5.52945H14.1822ZM6.15415 6.77843H17.8458C18.957 6.77843 19.9179 7.43965 20.4284 8.39475L18.7968 12.3831C18.6466 12.7609 17.966 13.1598 17.025 13.1598H14.4424V13.0443C14.4424 12.509 14.022 12.0682 13.5115 12.0682H10.4885C9.97798 12.0682 9.55756 12.509 9.55756 13.0443V13.1598H7.30531C6.39439 13.1598 5.72372 12.7714 5.55355 12.4146L3.6016 8.36327C4.1021 7.41866 5.05305 6.77843 6.15415 6.77843ZM3.2012 16.6233C3.2012 18.3341 4.53253 19.7195 6.15415 19.7195H17.8458C19.4775 19.7195 20.7988 18.3341 20.7988 16.6128V10.6723L19.8979 12.8764C19.5175 13.8 18.3664 14.4192 17.025 14.4192H14.4424V14.4822C14.4424 15.0175 14.022 15.4583 13.5115 15.4583H10.4885C9.97798 15.4583 9.55756 15.0175 9.55756 14.4822V14.4192H7.30531C6.01401 14.4192 4.9029 13.8525 4.48248 12.9813L3.2012 10.3259V16.6233Z"
      fill="currentColor"
    />
  </svg>
);

export default WorkIcon;
